module.exports = __webpack_public_path__ + "static/Zheng Zheng.a0c12c57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Zheng Zheng.jpg
// module id = 1247
// module chunks = 6166952557895